import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { aziendaGuard } from './guards/azienda.guard';
import { maintenanceGuard } from './guards/maintenance.guard';
import { DoppiaSurveyEsternaComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-doppia-materialita-compila-survey/doppia-survey-esterna/doppia-survey-esterna.component';
import { DoppiaMaterialitaComponent } from './page/analisi-materialita/doppia-materialita/doppia-materialita.component';
import { MaterialitaComponent } from './page/analisi-materialita/materialita/materialita.component';
import { StakeholderComponent } from './page/analisi-materialita/stakeholder/stakeholder.component';
import { AutovalutazioneEsternoComponent } from './page/autovalutazione-esterno/autovalutazione-esterno.component';
import { AutovalutazioniComponent } from './page/autovalutazioni/autovalutazioni.component';
import { AziendeComponent } from './page/aziende/aziende.component';
import { FigureAziendeComponent } from './page/aziende/figure-aziende/figure-aziende.component';
import { BilancioSostebilitaComponent } from './page/bilancio-sostebilita/bilancio-sostebilita.component';
import { BilancioSostenibilitaEsternaComponent } from './page/bilancio-sostenibilita-esterna/bilancio-sostenibilita-esterna.component';
import { BucketDocumentiComponent } from './page/bucket-documenti/bucket-documenti.component';
import { CfgAmbitiComponent } from './page/configurazioni/cfg-ambiti/cfg-ambiti.component';
import { CfgAutovalutazioniComponent } from './page/configurazioni/cfg-autovalutazioni/cfg-autovalutazioni.component';
import { CfgAzioneEBuonaPraticaComponent } from './page/configurazioni/cfg-azione-e-buona-pratica/cfg-azione-e-buona-pratica.component';
import { CfgCategorieStakeholderComponent } from './page/configurazioni/cfg-categorie-stakeholder/cfg-categorie-stakeholder.component';
import { CfgCertificazioniComponent } from './page/configurazioni/cfg-certificazioni/cfg-certificazioni.component';
import { CfgComitatiComponent } from './page/configurazioni/cfg-comitati/cfg-comitati.component';
import { CfgDestinatariPolicyComponent } from './page/configurazioni/cfg-destinatari-policy/cfg-destinatari-policy.component';
import { CfgEsrsComponent } from './page/configurazioni/cfg-esrs/cfg-esrs.component';
import { CfgGeneralPromptComponent } from './page/configurazioni/cfg-general-prompt/cfg-general-prompt.component';
import { CfgImpattiComponent } from './page/configurazioni/cfg-impatti/cfg-impatti.component';
import { CfgImpegniComponent } from './page/configurazioni/cfg-impegni/cfg-impegni.component';
import { CfgInformativaAziendaleComponent } from './page/configurazioni/cfg-informativa-aziendale/cfg-informativa-aziendale.component';
import { CfgKPIComponent } from './page/configurazioni/cfg-kpi/cfg-kpi.component';
import { CfgLineeGuidaStampeComponent } from './page/configurazioni/cfg-linee-guida-stampe/cfg-linee-guida-stampe.component';
import { CfgModelliSviluppoPianoComponent } from './page/configurazioni/cfg-modelli-sviluppo-piano/cfg-modelli-sviluppo-piano.component';
import { CfgObiettiviAziendaliComponent } from './page/configurazioni/cfg-obiettivi-aziendali/cfg-obiettivi-aziendali.component';
import { CfgObiettiviPianoComponent } from './page/configurazioni/cfg-obiettivi-piano/cfg-obiettivi-piano.component';
import { CfgPerimetroApplicazionePolicyComponent } from './page/configurazioni/cfg-perimetro-applicazione-policy/cfg-perimetro-applicazione-policy.component';
import { CfgScritturaImpattoComponent } from './page/configurazioni/cfg-scrittura-impatto/cfg-scrittura-impatto/cfg-scrittura-impatto.component';
import { CfgSettoriComponent } from './page/configurazioni/cfg-settori/cfg-settori.component';
import { CfgStandardRendicontazioneComponent } from './page/configurazioni/cfg-standard-rendicontazione/cfg-standard-rendicontazione.component';
import { CfgTematicheComponent } from './page/configurazioni/cfg-tematiche/cfg-tematiche.component';
import { CfgUnitaDiMisuraComponent } from './page/configurazioni/cfg-unita-di-misura/cfg-unita-di-misura.component';
import { DashboardAziendaComponent } from './page/dashboard-azienda/dashboard-azienda.component';
import { DashboardComponent } from './page/dashboard/dashboard.component';
import { HomeComponent } from './page/home/home.component';
import { InformativaAziendaleEsternaComponent } from './page/informativa-aziendale-esterna/informativa-aziendale-esterna.component';
import { LoginComponent } from './page/login/login.component';
import { ManutenzioneComponent } from './page/manutenzione/manutenzione.component';
import { PasswordDimenticataComponent } from './page/password-dimenticata/password-dimenticata.component';
import { PianoSostenibilitaEsternaComponent } from './page/piano-sostenibilita-esterna/piano-sostenibilita-esterna.component';
import { PianoSostenibilitaComponent } from './page/piano-sostenibilita/piano-sostenibilita.component';
import { PolicySostenibilitaEsternaComponent } from './page/policy-sostenibilita-esterna/policy-sostenibilita-esterna.component';
import { PolicySostenibilitaComponent } from './page/policy-sostenibilita/policy-sostenibilita.component';
import { ReportVsmeEsternaComponent } from './page/report-vsme-esterna/report-vsme-esterna.component';
import { ReportVsmeComponent } from './page/report-vsme/report-vsme.component';
import { ResetPasswordComponent } from './page/reset-password/reset-password.component';
import { SintesiSostenibilitaEsternaComponent } from './page/sintesi-sostenibilita-esterna/sintesi-sostenibilita-esterna.component';
import { SintesiSostenibilitaComponent } from './page/sintesi-sostenibilita/sintesi-sostenibilita.component';
import { StatisticheComponent } from './page/statistiche/statistiche.component';
import { SurveyEsternoComponent } from './page/survey-esterno/survey-esterno.component';
import { UtentiComponent } from './page/utenti/utenti.component';
import { ValidazioneIroEsternaComponent } from './page/validazione-iro-esterna/validazione-iro-esterna.component';

const routes: Routes = [
  //  Pagina di manutenzione (nessuna guardia qui!)
  { path: 'manutenzione', component: ManutenzioneComponent },

  //  Tutto il resto passa prima per la guardia
  {
    path: '',
    canActivate: [maintenanceGuard],
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'password-dimenticata', component: PasswordDimenticataComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'attiva-account', component: ResetPasswordComponent },
      { path: 'compilazione-survey', component: SurveyEsternoComponent },
      { path: 'compilazione-autovalutazione', component: AutovalutazioneEsternoComponent },
      {
        path: 'compilazione-sintesi-sostenibilita',
        component: SintesiSostenibilitaEsternaComponent,
      },
      {
        path: 'compilazione-bilancio-sostenibilita',
        component: BilancioSostenibilitaEsternaComponent,
      },
      { path: 'compilazione-report-vsme', component: ReportVsmeEsternaComponent },
      { path: 'compilazione-policy-sostenibilita', component: PolicySostenibilitaEsternaComponent },
      { path: 'compilazione-piano-sostenibilita', component: PianoSostenibilitaEsternaComponent },
      {
        path: 'compilazione-informativa-aziendale',
        component: InformativaAziendaleEsternaComponent,
        data: { tipoModulo: 'BILANCIO' },
      },
      {
        path: 'compilazione-informativa-aziendale-vsme',
        component: InformativaAziendaleEsternaComponent,
        data: { tipoModulo: 'REPORT_VSME' },
      },
      { path: 'compilazione-validazione-iro', component: ValidazioneIroEsternaComponent },
      { path: 'compilazione-doppia-survey', component: DoppiaSurveyEsternaComponent },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [authGuard],
        children: [
          { path: 'dashboard', component: DashboardComponent },
          { path: 'dashboard-azienda', component: DashboardAziendaComponent },
          { path: 'materialita', component: MaterialitaComponent, canActivate: [aziendaGuard] },
          {
            path: 'doppia-materialita',
            component: DoppiaMaterialitaComponent,
            canActivate: [aziendaGuard],
          },
          { path: 'stakeholder', component: StakeholderComponent, canActivate: [aziendaGuard] },
          {
            path: 'report-di-sostenibilità',
            component: BilancioSostebilitaComponent,
            canActivate: [aziendaGuard],
          },
          { path: 'report-vsme', component: ReportVsmeComponent, canActivate: [aziendaGuard] },
          {
            path: 'sostenibilita',
            component: SintesiSostenibilitaComponent,
            canActivate: [aziendaGuard],
          },
          { path: 'statistiche', component: StatisticheComponent },
          { path: 'assessment', component: AutovalutazioniComponent, canActivate: [aziendaGuard] },
          { path: 'aziende', component: AziendeComponent },
          {
            path: 'policy-sostenibilita',
            component: PolicySostenibilitaComponent,
            canActivate: [aziendaGuard],
          },
          {
            path: 'piano-sostenibilita',
            component: PianoSostenibilitaComponent,
            canActivate: [aziendaGuard],
          },
          { path: 'utenti', component: UtentiComponent },
          {
            path: 'bucket-documenti',
            component: BucketDocumentiComponent,
            canActivate: [aziendaGuard],
          },
          /* { path: 'riepilogo-licenze', component: RiepilogoLicenzeComponent, canActivate: [aziendaGuard]}, */
          {
            path: 'figure-aziendali',
            component: FigureAziendeComponent,
            canActivate: [aziendaGuard],
          },
          {
            path: 'comitati',
            component: CfgComitatiComponent,
            data: { perAzienda: true },
            canActivate: [aziendaGuard],
          },
          { path: 'configurazioni-ambiti', component: CfgAmbitiComponent },
          { path: 'configurazioni-tematiche', component: CfgTematicheComponent },
          { path: 'configurazioni-esrs', component: CfgEsrsComponent },
          { path: 'configurazioni-impatti', component: CfgImpattiComponent },
          {
            path: 'configurazioni-standard-rendicontazione',
            component: CfgStandardRendicontazioneComponent,
          },
          { path: 'configurazioni-autovalutazioni', component: CfgAutovalutazioniComponent },
          { path: 'configurazioni-cate-stakeholder', component: CfgCategorieStakeholderComponent },
          { path: 'configurazioni-scrittura-impatto', component: CfgScritturaImpattoComponent },
          { path: 'configurazioni-settori', component: CfgSettoriComponent },
          {
            path: 'configurazioni-informativa-aziendale',
            component: CfgInformativaAziendaleComponent,
          },
          { path: 'configurazioni-impegni', component: CfgImpegniComponent },
          { path: 'configurazioni-KPI', component: CfgKPIComponent },
          {
            path: 'configurazioni-azione-e-buona-pratica',
            component: CfgAzioneEBuonaPraticaComponent,
          },
          { path: 'configurazioni-unita-di-misura', component: CfgUnitaDiMisuraComponent },
          { path: 'configurazioni-certificazioni', component: CfgCertificazioniComponent },
          {
            path: 'configurazioni-comitati',
            component: CfgComitatiComponent,
            data: { perAzienda: false },
          },
          { path: 'configurazioni-destinatari-policy', component: CfgDestinatariPolicyComponent },
          {
            path: 'configurazioni-perimetro-app-policy',
            component: CfgPerimetroApplicazionePolicyComponent,
          },
          { path: 'configurazioni-linee-guida-stampe', component: CfgLineeGuidaStampeComponent },
          { path: 'configurazioni-obiettivi-piano', component: CfgObiettiviPianoComponent },
          {
            path: 'configurazioni-obiettivi-aziendali-piano',
            component: CfgObiettiviAziendaliComponent,
          },
          {
            path: 'configurazioni-modelli-sviluppo-piano',
            component: CfgModelliSviluppoPianoComponent,
          },
          { path: 'configurazioni-general-prompt', component: CfgGeneralPromptComponent },
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        ],
      },

      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },

  // Fallback
  { path: '**', redirectTo: 'login' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      errorHandler: (error) => {
        console.error('Errore di navigazione', error);
        // Puoi aggiungere logiche di gestione errori personalizzate qui
      },
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
